import React, { Component, Fragment } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { bindActionCreators } from "redux";
import { Router } from "../../routes";
import { selectProduct,
  selectExperience,
  selectDistance,
  selectPrice,
  selectSortType,
  selectProductDefault,
  selectExperienceDefault,
  selectDistanceDefault,
  selectPriceDefault,
  selectSortTypeDefault,
} from "../../redux/actions";
import { initialState } from '../../redux/reducers/userPreferencesReducer';
import SelectorModalMobile from '../../containers/SelectorModalMobile'
import { getPluralProductName, slugify, Filter, getCategory } from '../../utils';
import { Checkbox } from "../index";
import { RangeSlider } from "../../containers/index";
import {
  MobileTabsContainer,
  MobileTab,
  CheckboxList,
  FilterHeader,
  ModalDivider,
} from './styles';

const initialUserPreferences = initialState;
const mapStateToProps = state => ({
  product: state.userPreferences.product,
  experience: state.userPreferences.experience,
  distance: state.userPreferences.distance,
  price: state.userPreferences.price,
  market: state.userPreferences.city.market,
  sortType: state.userPreferences.sortType,
});

const mapDispatchToProps = dispatch => bindActionCreators({
  handleProductSelection: selectProduct,
  handleExperienceSelection: selectExperience,
  handleDistanceSelection: selectDistance,
  handlePriceSelection: selectPrice,
  handleSortTypeSelection: selectSortType,
  handleDefaultProductSelection: selectProductDefault,
  handleDefaultExperienceSelection: selectExperienceDefault,
  handleDefaultDistanceSelection: selectDistanceDefault,
  handleDefaultPriceSelection: selectPriceDefault,
  handleDefaultSortTypeSelection: selectSortTypeDefault,
}, dispatch);

@connect(mapStateToProps, mapDispatchToProps)
class MobileFilterPanel extends Component {
  static propTypes = {
    price: PropTypes.oneOfType([PropTypes.instanceOf(Object), PropTypes.string]),
    total: PropTypes.number,
    distance: PropTypes.oneOfType([PropTypes.instanceOf(Object), PropTypes.string]),
    sortType: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
    experience: PropTypes.string,
    product: PropTypes.string,
    handleProductSelection: PropTypes.func,
    handleExperienceSelection: PropTypes.func,
    handlePriceSelection: PropTypes.func,
    handleDistanceSelection: PropTypes.func,
    handleSortTypeSelection: PropTypes.func,
    handleDefaultProductSelection: PropTypes.func,
    handleDefaultExperienceSelection: PropTypes.func,
    handleDefaultDistanceSelection: PropTypes.func,
    handleDefaultPriceSelection: PropTypes.func,
    handleDefaultSortTypeSelection: PropTypes.func,
    market: PropTypes.string,
    loading: PropTypes.bool,
  };

  constructor(props) {
    super(props);

    this.state = {
      openedModal: null,
    }
  }

  setFiltersDefault = () => {
    const {
      handleDefaultProductSelection,
      handleDefaultExperienceSelection,
      handleDefaultDistanceSelection,
      handleDefaultPriceSelection,
      handleDefaultSortTypeSelection,
      market,
    } = this.props;

    const { toggleModal } = this;
    const { product, experience, distance, price } = initialUserPreferences;
    const { priceHi, priceLo } = price;
    const { distanceLo, distanceHi } = distance;

    Router.pushRoute('search', {
      ...Router.query,
      marketName: slugify(market),
      category: 'day-passes',
      product,
      experience,
      distanceLo,
      distanceHi,
      priceLo,
      priceHi,
    }, { shallow: true });

    handleDefaultProductSelection();
    handleDefaultExperienceSelection();
    handleDefaultDistanceSelection();
    handleDefaultPriceSelection();
    handleDefaultSortTypeSelection();
    toggleModal();
  };

  handleCheckboxSelect = evt => {
    const { handleProductSelection, product, market } = this.props;
    const { target } = evt;
    let checkboxOptions;

    if (Router.query.product) {
      checkboxOptions = Router.query.product.split(',');
    } else {
      checkboxOptions = product.split(',');
    }

    const containedOptionIndex = checkboxOptions.findIndex(option => option.trim() === target.value);

    if (checkboxOptions.length === 0) {
      checkboxOptions = [target.value];
    } else if (containedOptionIndex !== -1) {
      checkboxOptions.splice(containedOptionIndex, 1);
    } else {
      checkboxOptions.push(target.value);
    }

    const filteredCheckboxOptions = checkboxOptions.filter(option => option.length !== 0);
    const selectedProduct = filteredCheckboxOptions.join(',');

    Router.pushRoute('search', {
      ...Router.query,
      marketName: slugify(market),
      category: filteredCheckboxOptions.length > 1 ? 'day-passes' : slugify(getPluralProductName(selectedProduct, 2)),
      product: selectedProduct,
    }, { shallow: true });

    handleProductSelection(selectedProduct);
  };

  handleExpirienceCheckboxSelect = evt => {
    const { handleExperienceSelection, product, market } = this.props;
    const { target } = evt;
    let checkboxOptions;

    if (Router.query.experience) {
      checkboxOptions = Router.query.experience.split(',');
    } else {
      checkboxOptions = [];
    }

    const containedOptionIndex = checkboxOptions.findIndex(
      option => option.trim() === target.value,
    );
    if (checkboxOptions.length === 0) {
      checkboxOptions = [target.value];
    } else if (containedOptionIndex !== -1) {
      checkboxOptions.splice(containedOptionIndex, 1);
    } else {
      checkboxOptions.push(target.value);
    }

    const filteredCheckboxOptions = checkboxOptions.filter(option => option.length !== 0);
    const experience = filteredCheckboxOptions.join(',');

    Router.pushRoute('search', {
      ...Router.query,
      marketName: slugify(market),
      category: getCategory(product),
      experience,
    }, { shallow: true });

    handleExperienceSelection(experience);
  };

  handleDistanceSelect = evt => {
    const { handleDistanceSelection, distance, product, market } = this.props;
    const { target } = evt;
    const { value } = target;

    const newDistanceLo = Number(value.split('-')[0]);
    const newDistanceHi = Number(value.split('-')[1]);

    const selectedDistanceLo = Number(distance.distanceLo);
    const selectedDistanceHi = Number(distance.distanceHi);

    Router.pushRoute('search', {
      ...Router.query,
      marketName: slugify(market),
      category: getCategory(product),
      distanceLo: newDistanceLo === selectedDistanceLo ? 0 : newDistanceLo,
      distanceHi: newDistanceHi === selectedDistanceHi ? 0 : newDistanceHi,
    }, { shallow: true });

    handleDistanceSelection({
      distanceLo: newDistanceLo === selectedDistanceLo ? 0 : newDistanceLo,
      distanceHi: newDistanceHi === selectedDistanceHi ? 0 : newDistanceHi,
    });
  };

  handlePriceSelect = value => {
    const { handlePriceSelection, product, market } = this.props;

    const priceLo = Number(value.min);
    const priceHi = Number(value.max);

    Router.pushRoute('search', {
      ...Router.query,
      marketName: slugify(market),
      category: getCategory(product),
      priceLo,
      priceHi,
    }, { shallow: true });

    handlePriceSelection({
      priceLo,
      priceHi,
    });
  };

  handleSortTypeChange = evt => {
    const { handleSortTypeSelection, product, market } = this.props;
    const { target } = evt;
    const sortType = Number(target.value);

    Router.pushRoute('search', {
      ...Router.query,
      marketName: slugify(market),
      category: getCategory(product),
      sortType,
    }, { shallow: true });

    handleSortTypeSelection(sortType);
  };

  toggleModal = () => {
    const bodyTag = document.querySelector('body');
    bodyTag.classList.toggle('noscroll');
    this.setState(prevState => ({
      openedModal: !prevState.openedModal,
    }));
  };

  render() {
    const { openedModal } = this.state;
    const { toggleModal, handleCheckboxSelect, handleExpirienceCheckboxSelect, handleDistanceSelect, handlePriceSelect, setFiltersDefault, handleSortTypeChange } = this;
    const { product, experience, distance, price, total, loading, sortType } = this.props;

    const distanceHi = parseInt(distance.distanceHi, 10);
    const distanceLo = parseInt(distance.distanceLo, 10);
    const priceHi = parseInt(price.priceHi, 10);
    const priceLo = parseInt(price.priceLo, 10);
    const selectedAllProduct = product === "Day Pass,Cabana,Spa Pass,Daybed,Fitness Pass,Beach Day Pass,Pool and Beach Day Pass,Events";
    const selectedAllExperience = experience === "Festive,Family,Tranquil";

    return (
      <Fragment>
        <MobileTabsContainer>
          <MobileTab onClick={toggleModal} type="button">
            <Filter />
            Filters
          </MobileTab>
        </MobileTabsContainer>
        {openedModal && (
          <SelectorModalMobile handleCloseButtonClick={toggleModal} total={total} loading={loading} handleClearButtonClick={setFiltersDefault}>
            <FilterHeader>Day Pass</FilterHeader>
            <CheckboxList onChange={handleCheckboxSelect}>
              <li>
                <Checkbox
                  checkboxToRight
                  readonly
                  description="General pool access typically includes fitness center"
                  name="Day Pass"
                  value="Day Pass"
                  checked={product.split(',').includes('Day Pass') && !selectedAllProduct}
                  id={0}
                  label="Day Pass"
                />
              </li>
              <li>
                <Checkbox
                  checkboxToRight
                  readonly
                  description="Covered sofas include reserved seating for 4-6 guests"
                  name="Cabana"
                  value="Cabana"
                  checked={product.split(',').includes('Cabana') && !selectedAllProduct}
                  id={1}
                  label="Cabana"
                />
              </li>
              <li>
                <Checkbox
                  checkboxToRight
                  readonly
                  description="General pool access plus spa facilities typically paired with a mini treatment"
                  name="Spa Pass"
                  value="Spa Pass"
                  checked={product.split(',').includes('Spa Pass') && !selectedAllProduct}
                  id={2}
                  label="Spa Pass"
                />
              </li>
              <li>
                <Checkbox
                  checkboxToRight
                  readonly
                  description="Semi-covered bed for 2-4 guests typically includes water, bottle of bubbly and fruit"
                  name="Daybed"
                  value="Daybed"
                  checked={product.split(',').includes('Daybed') && !selectedAllProduct}
                  id={3}
                  label="Daybed"
                />
              </li>
              <li>
                <Checkbox
                  checkboxToRight
                  readonly
                  description="Fitness center access and fitness classes"
                  name="Fitness Pass"
                  value="Fitness Pass"
                  checked={product.split(',').includes('Fitness Pass') && !selectedAllProduct}
                  id={4}
                  label="Fitness Pass"
                />
              </li>
              <li>
                <Checkbox
                    checkboxToRight
                    readonly
                    description=""
                    name="Beach Day Pass"
                    value="Beach Day Pass"
                    checked={product.split(',').includes('Beach Day Pass') && !selectedAllProduct}
                    id={7}
                    label="Beach Day Pass"
                />
              </li>
              <li>
                <Checkbox
                    checkboxToRight
                    readonly
                    description=""
                    name="Pool and Beach Day Pass"
                    value="Pool and Beach Day Pass"
                    checked={product.split(',').includes('Pool and Beach Day Pass') && !selectedAllProduct}
                    id={8}
                    label="Pool and Beach Day Pass"
                />
              </li>
              <li>
                <Checkbox
                  checkboxToRight
                  readonly
                  description="General pool access paired with special events & activities"
                  name="Events"
                  value="Events"
                  checked={product.split(',').includes('Events') && !selectedAllProduct}
                  id={5}
                  label="Events"
                />
              </li>
            </CheckboxList>

            <ModalDivider />

            <FilterHeader>Experience Type</FilterHeader>
            <CheckboxList onChange={handleExpirienceCheckboxSelect}>
              <li>
                <Checkbox
                  checkboxToRight
                  readonly
                  description="Lively vibe, upbeat poolside music, social events and pool parties"
                  name="Festive"
                  value="Festive"
                  checked={experience.includes('Festive') && !selectedAllExperience}
                  id="Festive"
                  label="Festive"
                />
              </li>
              <li>
                <Checkbox
                  checkboxToRight
                  readonly
                  description="Kids programs, child-friendly features, water parks"
                  name="Family"
                  value="Family"
                  checked={experience.includes('Family') && !selectedAllExperience}
                  id="Family"
                  label="Family"
                />
              </li>
              <li>
                <Checkbox
                  checkboxToRight
                  readonly
                  description="A calm and peaceful vibe to relax and recharge"
                  name="Tranquil"
                  value="Tranquil"
                  checked={experience.includes('Tranquil') && !selectedAllExperience}
                  id="Tranquil"
                  label="Tranquil"
                />
              </li>
            </CheckboxList>

            <ModalDivider />

            <FilterHeader>Price</FilterHeader>
            <RangeSlider
              currentMinValue={priceLo}
              currentMaxValue={priceHi || 300}
              handleSliderChange={handlePriceSelect}
            />

            <ModalDivider />

            <FilterHeader>Distance</FilterHeader>
            <CheckboxList onChange={handleDistanceSelect}>
              <li>
                <Checkbox
                  name="< 10 miles"
                  value="0-10"
                  checkboxToRight
                  checked={distanceHi === 10}
                  id="< 10 miles"
                  label="< 10 miles"
                />
              </li>
              <li>
                <Checkbox
                  name="10 - 20 miles"
                  value="10-20"
                  checkboxToRight
                  checked={distanceLo === 10 && distanceHi === 20}
                  id="10 - 20 miles"
                  label="10 - 20 miles"
                />
              </li>
              <li>
                <Checkbox
                  name="20 - 40 miles"
                  value="20-40"
                  checkboxToRight
                  checked={distanceLo === 20 && distanceHi === 40}
                  id="20 - 40 miles"
                  label="20 - 40 miles"
                />
              </li>
              <li>
                <Checkbox
                  name="40 - 100 miles"
                  value="40-100"
                  checkboxToRight
                  checked={distanceLo === 40 && distanceHi === 100}
                  id="40 - 100 miles"
                  label="40 - 100 miles"
                />
              </li>
              <li>
                <Checkbox
                  name="> 100 miles"
                  value="100-9999"
                  checkboxToRight
                  checked={distanceLo === 100}
                  id="> 100 miles"
                  label="> 100 miles"
                />
              </li>
            </CheckboxList>

            <ModalDivider />

            <FilterHeader>Sorting</FilterHeader>
            <CheckboxList onChange={handleSortTypeChange}>
              <li>
                <Checkbox
                  name="Most Popular"
                  value="0"
                  checkboxToRight
                  checked={Number(sortType) === 0}
                  id="Most Popular"
                  label="Most Popular"
                />
              </li>
              <li>
                <Checkbox
                  name="Cheapest"
                  value="1"
                  checkboxToRight
                  checked={Number(sortType) === 1}
                  id="Cheapest"
                  label="Cheapest"
                />
              </li>
              <li>
                <Checkbox
                  name="Closest"
                  value="2"
                  checkboxToRight
                  checked={Number(sortType) === 2}
                  id="Closest"
                  label="Closest"
                />
              </li>
            </CheckboxList>
          </SelectorModalMobile>
        )}
      </Fragment>
  )}
}

export default MobileFilterPanel;
